// AuthtorizationLancamentoRag.js

import { useState, useEffect } from "react";
import { buscarProrrogacaoPorAcao, buscarProrrogacaoPorPrograma } from "../../../service/Rag/AvaliacaoPrograma";

export function usePerfil(user) {
  const [isMONRL_LANCAMENTO, setMONRLLancamento] = useState(false);
  const [isMONRL_ADMIN_CENTRAL, setMONRLAdminCentral] = useState(false);
  const [isMONRL_ADMIN_SETORIAL, setMONRLAdminSetorial] = useState(false);
  const [isMONRL_ANALISTA, setMONRLAnalista] = useState(false);
  const [isMONRL_ACESSO_ORGAO_CONTROLE, setMONRLAcessoOrgaoControle] = useState(false);
  const [prorrogacaoPrograma, setProrrogacaoPrograma] = useState([]);

  useEffect(() => {
    if (user) {
      const roles = user.contaAcesso.authorities.map((perfil) => perfil.nomeRole);
      setMONRLLancamento(roles.includes("MONRL_LANCAMENTO"));
      setMONRLAdminCentral(roles.includes("MONRL_ADMIN_CENTRAL"));
      setMONRLAdminSetorial(roles.includes("MONRL_ADMIN_SETORIAL"));
      setMONRLAnalista(roles.includes("MONRL_ANALISTA"));
      setMONRLAcessoOrgaoControle(roles.includes("MONRL_ACESSO_ORGAO_CONTROLE"));
    }
  }, [user]);

  return {
    isMONRL_LANCAMENTO,
    isMONRL_ADMIN_CENTRAL,
    isMONRL_ADMIN_SETORIAL,
    isMONRL_ANALISTA,
    isMONRL_ACESSO_ORGAO_CONTROLE,
  };
}

export async function handleShowModalLancamentos(
  data,
  cronograma,
  user,
  parametroExercicio,
  history,
  isMONRL_LANCAMENTO,
  isMONRL_ADMIN_CENTRAL,
  isMONRL_ADMIN_SETORIAL,
  isMONRL_ANALISTA
) {
  let prorrogacaoPrograma = [];
  let prorrogacaoAcao = [];

  if (data.tipoItem === "AÇÃO") {
    await buscarProrrogacaoPorAcao(data.idenPtaFiplan).then((res) => {
      prorrogacaoAcao = res.data;
    });
  } else {
    await buscarProrrogacaoPorPrograma(data.programa.idenPrograma).then((res) => {
      prorrogacaoPrograma = res.data;
    });
  }

  /* VERIFICAÇÕES DE HABILITAÇÃO DA AVALIAÇÃO */
  let podeAvaliarPrograma =
    (cronograma.programa.avaliacao && data.permissaoItem !== null && data.permissaoItem === "E") ||
    (cronograma.programa.avaliacao &&
      data.idenPessoaResp !== null &&
      data.idenPessoaResp === user.contaAcesso.pessoa.idenPessoa) ||
    (data.isProrrogaAvaliacao === "S" &&
      data.idenPessoaResp !== null &&
      data.idenPessoaResp === user.contaAcesso.pessoa.idenPessoa) ||
    (data.isProrrogaAvaliacao === "S" && data.permissaoItem !== null && data.permissaoItem === "E");

  let podeAvaliarIndicador =
    cronograma.indicador.avaliacao &&
    data.idenPessoaResp !== null &&
    data.idenPessoaResp === user.contaAcesso.pessoa.idenPessoa;

  let podeAvaliarAcao =
    (cronograma.acao.avaliacao && data.permissaoItem !== null && data.permissaoItem === "E") ||
    (cronograma.acao.avaliacao &&
      data.idenPessoaResp !== null &&
      data.idenPessoaResp === user.contaAcesso.pessoa.idenPessoa) ||
    (data.isProrrogaAvaliacao === "S" &&
      data.idenPessoaResp !== null &&
      data.idenPessoaResp === user.contaAcesso.pessoa.idenPessoa) ||
    (data.isProrrogaAvaliacao === "S" && data.permissaoItem !== null && data.permissaoItem === "E");

  /* VERIFICAÇÕES DE HABILITAÇÃO DAS ANÁLISES */
  let podeAnalisarPrograma =
    cronograma.programa.analise &&
    (isMONRL_ANALISTA || isMONRL_ADMIN_CENTRAL || isMONRL_LANCAMENTO || isMONRL_ADMIN_SETORIAL);

  let podeAnalisarIndicador =
    cronograma.indicador.analise &&
    (isMONRL_ANALISTA || isMONRL_ADMIN_CENTRAL || isMONRL_LANCAMENTO || isMONRL_ADMIN_SETORIAL);
  let podeAnalisarAcao =
    cronograma.acao.analise &&
    (isMONRL_ANALISTA || isMONRL_ADMIN_CENTRAL || isMONRL_LANCAMENTO || isMONRL_ADMIN_SETORIAL);

  /* VERIFICAÇÕES DE HABILITAÇÃO DA ABA DE SUSGESTÃO DE MELHORIA */
  let PODE_ENVIAR_SUGESTAO_MELHORIA_PROGRAMA = false;

  if (isMONRL_LANCAMENTO) {
    if (data.idenPessoaResp !== null && data.idenPessoaResp === user.contaAcesso.pessoa.idenPessoa)
      PODE_ENVIAR_SUGESTAO_MELHORIA_PROGRAMA =
        (cronograma &&
          typeof cronograma === "object" &&
          (Object.values(cronograma.programa || {}).includes(true) ||
            Object.values(cronograma.indicador || {}).includes(true))) ||
        (prorrogacaoPrograma && prorrogacaoPrograma.length > 0);
  }

  if (isMONRL_ANALISTA || isMONRL_ADMIN_CENTRAL || isMONRL_ADMIN_SETORIAL) {
    PODE_ENVIAR_SUGESTAO_MELHORIA_PROGRAMA =
      (cronograma &&
        typeof cronograma === "object" &&
        (Object.values(cronograma.programa || {}).includes(true) ||
          Object.values(cronograma.indicador || {}).includes(true))) ||
      (prorrogacaoPrograma && prorrogacaoPrograma.length > 0);
  }

  let PODE_ENVIAR_SUGESTAO_MELHORIA_ACAO = false;

  if (isMONRL_LANCAMENTO) {
    if (data.idenPessoaResp !== null && data.idenPessoaResp === user.contaAcesso.pessoa.idenPessoa) {
      PODE_ENVIAR_SUGESTAO_MELHORIA_ACAO =
        (cronograma?.acao && typeof cronograma.acao === "object" && Object.values(cronograma.acao).includes(true)) ||
        (prorrogacaoAcao && prorrogacaoAcao.length > 0);
    }
  }

  if (isMONRL_ANALISTA || isMONRL_ADMIN_CENTRAL || isMONRL_ADMIN_SETORIAL) {
    PODE_ENVIAR_SUGESTAO_MELHORIA_ACAO =
      (cronograma?.acao && typeof cronograma.acao === "object" && Object.values(cronograma.acao).includes(true)) ||
      (prorrogacaoAcao && prorrogacaoAcao.length > 0);
  }

  if (data.idenItemPai === "0") {
    history.push({
      pathname: "/avaliacao/programa",
      state: {
        data,
        parametroExercicio,
        podeAnalisarPrograma,
        podeAvaliarPrograma,
        podeAvaliarIndicador,
        podeAvaliarAcao,
        podeAnalisarIndicador,
        PODE_ENVIAR_SUGESTAO_MELHORIA_PROGRAMA,
      },
    });
  } else {
    history.push({
      pathname: "/avaliacao/acao",
      state: { data, parametroExercicio, podeAvaliarAcao, podeAnalisarAcao, PODE_ENVIAR_SUGESTAO_MELHORIA_ACAO },
    });
  }
}
